import api, { fetchData } from './api';
import Paginacao from '../types/paginacao';
import Client from '../types/client';

export interface ClientApiResponse {
  data: Client;
  messages: any; 
}

export const getClientsPaginated = async (
    paginacao: Paginacao
  ) => {
    try {
      const endpoint: string = '/Client/all/paginado';
      const params: Record<string, any> = {
        pageNum: paginacao.pageNum + 1,
        quantityPerPage: paginacao.quantityPerPage,
      };
  
      const response = await fetchData<Client>(endpoint, params);
  
      return response;
    } catch (error) {
      console.error('Erro ao buscar lista de suppliers:', error);
      throw error;
    }
};

export const getClients = async () => {
  try {
    const endpoint: string = 'Client/all';
    const response = await fetchData<Client>(endpoint, {});
    return response;
  } catch (error) {
    console.error(`Erro ao buscar clientes`, error);
    throw error;
  }
};
  
  export const getClientById = async (id: number) => {
    try {
      const response = await api.get(`/Client/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar client com ID ${id}`, error);
      throw error;
    }
  };

  export const deleteClient = async (id: number) => {
    try {
      const response = await api.delete(`/Client/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao excluir client com ID ${id}`, error);
      throw error;
    }
  };
  
  export const createClient = async (client: Client) => {
    try {
      const response = await api.post('Client', client);
      return response.data;
    } catch (error) {
      console.error('Erro ao cadastrar client');
      throw error;
    }
  };
  
  export const updateClient = async (id: number, client: Client) => {
    try {
      const response = await api.put(`/Client/update/${id}`, client);
      return response.data;
    } catch (error: any) {
      console.error('Error updating client:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      throw error;
    }
  };